<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="font-style" [ngbTooltip]="pipeSchedule_tooltip" placement="right" container="body"
        tooltipClass="small-tooltip">
        <!-- Pipe Schedule -->
        {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.PIPE_SCHEDULE' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #pipeSchedule_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.PIPE_SCHEDULE' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select *ngIf="!isCustom" formControlName="pipeSchedule" name="pipeSchedule" class="input-select"
        [class.spinner]="loading" (selectionChange)="selectPipeSchedule($event)" [class.select-disable]="enable">
        <mat-option class="option-list" *ngFor="let x of optionList" [value]="x.pipeScheduleId">{{ x.pipeScheduleName
            }}</mat-option>
    </mat-select>

    <input *ngIf="isCustom" class="input-form-class" matInput formControlName="customPipeSchedule"
        name="custom_PipeSchedule" />
</div>